import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationsUserThunk } from "../../redux/actions/user-actions";
import { updateConsultsThunk } from "../../redux/actions/consults-actions";
import NotificationsComponent from "../../components/navbar/notifications";

const Navbar = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const notifications = useSelector((state) => state.user.notifications);
  const status = useSelector((state) => state.user.notificationsStatus);

  // TODO: This causes the initial load to display no consults until the API call completes.
  //  useEffect(() => {
  //   dispatch(updateConsultsThunk(notifications));
  // }, [notifications]);

  useEffect(() => {
    if (user) {
      const interval = setInterval(() => user.id && dispatch(getNotificationsUserThunk()), 0.25 * 60 * 1000); //15 segs

      return function cleanup() {
        if (interval) {
          clearInterval(interval);
        }
      };
    }
  }, [user]);

  useEffect(() => {
    if (user.id) {
      dispatch(getNotificationsUserThunk());
    }
  }, [user.id]);

  return <NotificationsComponent notifications={notifications} user={user} status={status} />;
};

export default Navbar;
